<app-page-meta pageTitle="Alternative Investment opportunities in India | Low Risk Investments - finzy"
               tags="peer to peer lending, investment online, manage investments easily, low risk investments, safe investments, alternate investments, high returns, optimise risks, easy investments, p2p lending, investments in India, private money lenders, lending money, online lenders, p2p lender, p2p loans, online lending india, investment opportunities, alternative investments, peer to peer lending India"
               description="Invest with India's premier peer to peer lending platform and get risk optimized returns. P2P lending made easy for lenders. Get the best investment opportunities with Finzy. If you are a P2P lender looking for P2P loans or an alternative investment option, visit today!">
</app-page-meta>

<app-json-ld-schema schemaData="{{ schemaData }}"></app-json-ld-schema>

<app-header></app-header>

<div class="page-content" *ngIf="activeFinzyVersion === 'FINZY_V1'">
  <div class="container-fluid">
    <div class="badge hidden-xs visible-md-block visible-lg-block"
         [routerLink]="['/articles/finzy-gets-nbfc-p2p-certificate']">
      <img src="../../../assets/images/finzy_rbi_badge.png" alt="RBI badge for finzy's NBFC P2P certificate">
    </div>

    <section class="row banner">
      <div class="invest-banner vertical-centering-block col-xs-12">
        <div class="row">
          <h1 class="heading text-white col-xs-12">Easy Investments. Fair returns.</h1>
        </div>

        <div class="row">
          <p class="subheading col-xs-12">
            <span class="subheading-item text-white">Hand picked borrowers</span>
            <span class="separator hidden-xs"></span><br class="visible-xs-block"/>
            <span class="subheading-item text-white">Diversified Investments</span>
            <span class="separator hidden-xs"></span><br class="visible-xs-block"/>
            <span class="subheading-item text-white">Regular monthly returns</span>
          </p>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <button class="action-button invest-now-button" routerLink="/lenderintro"
                    (click)="analyticsTracker.trackButtonClick('Investor Home', 'Invest Now', 'Banner')">
              Invest Now
            </button>
          </div>
        </div>
      </div>
    </section>

    <app-common-invest-sections></app-common-invest-sections>

    <section class="row contact-us" id="contact-us">
      <div class="col-xs-10 col-lg-10 col-lg-offset-1 col-xs-offset-1">
        <app-contact-us form-position="left"></app-contact-us>
      </div>
    </section>

    <app-rbi-disclaimer></app-rbi-disclaimer>
  </div>
</div>

<div *ngIf="activeFinzyVersion == 'FINZY_V2'" class="show-latest-landing-page">
  <app-poster></app-poster>
  <app-nCash></app-nCash>
  <app-investment-sections></app-investment-sections>
</div>


<app-footer></app-footer>
